module.exports = __webpack_public_path__ + "font_anzu_daughter.983f355c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/font_anzu_daughter.png
// module id = oWbf
// module chunks = 0